import { Pipe, PipeTransform } from '@angular/core';
import { AdminData } from '../models/AdminData.model';
@Pipe({
  name: 'adminFilter'
})
export class AdminFilterPipe implements PipeTransform {

  transform(adminData: AdminData[], searchTerm: string): AdminData[] {
    if (!adminData || !searchTerm) { return adminData; }
    return adminData.filter(ad =>
      ad.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
      ||
      ad.emailId.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
      ||
      ad.hospitalName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
      ||
      ad.licenseNo.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
      ||
      ad.mobileNo.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
     




    );

  }

}
